import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { forgotPasswordThunk } from '../thunks/thunks';
import { useNavigate } from 'react-router';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const { isLoading:loading, success, error } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(forgotPasswordThunk(email))
      .unwrap()
      .then(() => {
        toast.success('Password reset link sent! Check your email.');
      })
      .catch((err) => {
        toast.error(err);
      });
    setTimeout(() => {
      navigate('/register');
    }, 2000);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-custom-pink">
      <div className='bg-white p-6 rounded-lg shadow-md w-[90%] max-w-md'>
      <h1 className="text-3xl font-bold text-black mb-6">Forgot Password</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-lg w-[90%] max-w-md"
      >
        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder='Enter your email'
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pink-500 focus:ring-pink-500 sm:text-sm p-2"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`w-full px-4 py-2 text-white font-semibold rounded-lg 
          ${loading ? 'bg-gray-400' : 'bg-black hover:bg-gray-500'} focus:outline-none`}
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
      {success && (
        <p className="text-green-500 mt-4">
          {success}
        </p>
      )}
      {error && (
        <p className="text-red-500 mt-4">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default ForgotPassword;
